import ManagerShare from "../../../classes/ManagerShare.js";

export const GET_MANAGER_SHARE = async ({ dispatch }, { userID, shareID }) => {
  return dispatch("GET_DOC", {
    converter: ManagerShare,
    path: ManagerShare.getPath(userID, shareID),
    stateKey: "managerShares",
    stateID: shareID,
  });
};

export const LISTEN_MANAGER_SHARES = async (
  { dispatch },
  { userID, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: ManagerShare,
    path: ManagerShare.getPath(userID),
    stateKey: "managerShares",
    next,
    error,
    unlisten,
  });
};

export const SAVE_MANAGER_SHARE = async (
  { dispatch },
  { userID, shareID, data }
) => {
  return dispatch("SET_DOC", {
    converter: ManagerShare,
    path: ManagerShare.getPath(userID, shareID),
    stateKey: "managerShares",
    stateID: shareID,
    data,
  });
};

export const DELETE_MANAGER_SHARE = async (
  { dispatch },
  { userID, shareID }
) => {
  return dispatch("DELETE_DOC", {
    path: ManagerShare.getPath(userID, shareID),
    stateKey: "managerShares",
    stateID: shareID,
  });
};
